// extracted by mini-css-extract-plugin
export var ratings = "ratings-module--ratings--3b34c";
export var ratingsInner = "ratings-module--ratingsInner--f2c60";
export var ratingsNum = "ratings-module--ratingsNum--83ad2";
export var ratingsStars = "ratings-module--ratingsStars--ba331";
export var ratingsTitle = "ratings-module--ratingsTitle--09d58";
export var ratingsVal = "ratings-module--ratingsVal--2fe15";